<template>
  <v-main>
    <div
      size="A4"
      layout="landscape"
      class="page-a4 container elevation-5">
      <v-row>
        <v-col cols="2">
          <img
            :src="gwLogo"
            alt="GW Logo"
            style="width: 100%; height: auto;"
            class="mt-2">
        </v-col>
        <v-col cols="10">
          <h3>
            GENTLEWOMAN COMPANY LIMITED (HEAD OFFICE)
          </h3>
          <v-divider
            class="my-2"
            style="border-color: #000000;" />
          <p style="font-size: 13px; margin: 0;">
            999/9 Room no. OFMH 3806-3812, 38th Floor, The Offices at Central World, Rama 1 Road, Pathumwan, Pathumwan, Bangkok 10330
            <br>Tax ID 0105561034561
          </p>
        </v-col>
        <v-col cols="12">
          <h1 class="text-center">
            TAX INVOICE
          </h1>
        </v-col>
        <v-col cols="12">
          <v-row
            no-gutters
            style="border: 1px solid #000; font-size: 12px;">
            <v-col
              cols="6"
              class="px-1 table-content"
              style="border-right: 1px solid #000;">
              <div class="table-row">
                <div class="table-header">
                  Bill To
                </div>
                <span>
                  {{ biller.name }}
                </span>
                <div class="table-header">
                  Branch
                </div>
                <span>
                  {{ biller.branch }}
                </span>
                <div class="table-header">
                  Address
                </div>
                <span>
                  {{ billerAddress }}
                </span>
                <div class="table-header">
                  Tax ID
                </div>
                <span>
                  {{ biller.taxRegistrationNumber }}
                </span>
                <div class="table-header">
                  Email
                </div>
                <span>
                  {{ biller.email }}
                </span>
                <div class="table-header">
                  Telephone No.
                </div>
                <span>
                  {{ biller.phoneNumber }}
                </span>
                <div class="table-header">
                  Credit term
                </div>
                <span>
                  30 days
                </span>
                <div class="table-header">
                  Payment Due Date
                </div>
                <span>
                  {{ paymentDueDate }}
                </span>
              </div>
            </v-col>
            <v-col
              cols="6"
              class="px-1 table-content">
              <div class="table-row">
                <div class="table-header">
                  No.
                </div>
                <span>
                  {{ formData.orderId }}
                </span>
                <div class="table-header">
                  Order Date
                </div>
                <span>
                  {{ formData.createdAt | dateUserFormat() }}
                </span>
                <div class="table-header">
                  Print Date
                </div>
                <span>
                  {{ new Date() | dateTimeUserFormat() }}
                </span>
                <div class="table-header">
                  Ship Address
                </div>
                <span>
                  {{ shippingAddress }}
                </span>
                <div class="table-header">
                  Email
                </div>
                <span>
                  {{ formData.shippingAddress.email }}
                </span>
                <div class="table-header">
                  Telephone No.
                </div>
                <span>
                  {{ formData.shippingAddress.contactNo }}
                </span>
                <div class="table-header">
                  Currency
                </div>
                <span>
                  THB
                </span>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <table
            border="1"
            class="item-table">
            <thead>
              <tr>
                <th style="width: 40px">
                  No
                </th>
                <th style="width: 110px">
                  Item Code
                </th>
                <th>Description</th>
                <th style="width: 80px">
                  Unit Price
                </th>
                <th style="width: 60px">
                  Quantity
                </th>
                <th style="width: 70px">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in formData.skus"
                :key="index"
                class="item-row">
                <td class="text-center">
                  {{ index + 1 }}
                </td>
                <td class="text-center">
                  {{ item.code }}
                </td>
                <td>
                  <span>
                    {{ item.name }}
                  </span>
                  <br>
                  <span class="text-capitalize">
                    {{ `${item.color} - ${item.size}` }}
                  </span>
                </td>
                <td class="text-right">
                  {{ (item.price / item.amount) | showNumberFormat() }}
                </td>
                <td class="text-right">
                  {{ item.amount | showNumberFormat() }} PCS
                </td>
                <td class="text-right">
                  {{ item.price | showNumberFormat() }}
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div
                    class="d-flex flex-column justify-space-between"
                    style="min-height: 108px;">
                    <div
                      class="d-flex flex-column"
                      style="width: 100%; height: 100%;">
                      <span
                        style="font-weight: bold;">
                        Note
                      </span>
                      <p class="white-space-pre">
                        {{ formData.note }}
                      </p>
                    </div>
                    <span>
                      **{{ numToText(afterVat) }}
                    </span>
                  </div>
                </td>
                <td colspan="5">
                  <table style="width: 100%;">
                    <tr>
                      <td style="font-weight: bold;">
                        Subtotal
                      </td>
                      <td class="text-right">
                        {{ totalPrice | showFullPriceFormat() }}
                      </td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">
                        Discount
                      </td>
                      <td class="text-right">
                        {{ totalDiscount | showFullPriceFormat() }}
                      </td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">
                        VAT ({{ vat }}%)
                      </td>
                      <td class="text-right">
                        {{ vatDiff | showFullPriceFormat() }}
                      </td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">
                        Net Amount
                      </td>
                      <td class="text-right">
                        {{ afterVat | showFullPriceFormat() }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="text-right"
            style="font-size: 13px;">
            * The price shown does not include any licensing fees
          </div>
        </v-col>
        <v-col cols="12">
          <div
            class="d-flex flex-row justify-space-between align-center px-5 mt-8"
            style="font-size: 13px;">
            <div class="d-flex flex-column align-center">
              <span style="font-weight: bold;">
                Preparer
              </span>
              <div style="position: relative; width: 120px">
                <v-divider
                  class="mt-4 mb-2"
                  style="border-color: #000;" />
              </div>
              <div
                class="d-flex flex-row"
                style="position: relative;">
                <span style="font-weight: bold;">
                  Date _________
                </span>
              </div>
            </div>
            <div class="d-flex flex-column align-center">
              <span style="font-weight: bold;">
                Approver
              </span>
              <div style="position: relative; width: 120px">
                <v-divider
                  class="mt-4 mb-2"
                  style="border-color: #000;" />
              </div>
              <div
                class="d-flex flex-row"
                style="position: relative;">
                <span style="font-weight: bold;">
                  Date _________
                </span>
              </div>
            </div>
            <div class="d-flex flex-column align-center">
              <span style="font-weight: bold;">
                Receiver
              </span>
              <div style="position: relative; width: 120px">
                <v-divider
                  class="mt-4 mb-2"
                  style="border-color: #000;" />
              </div>
              <div
                class="d-flex flex-row"
                style="position: relative;">
                <span style="font-weight: bold;">
                  Date _________
                </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'
import { ToWords } from 'to-words'
import OrderProvider from '@/resources/OrderProvider'
import BahtText from '@/assets/js/BahtText'
import GWLogo from '@/assets/image/GTWM_Main_Logo-02.png'
import ShippingCountries from '@/assets/json/ShippingCountries.json'

const OrderService = new OrderProvider()

export default {
  data () {
    return {
      loading: false,
      vat: 0,
      orders: [],
      biller: {
        name: '',
        branch: '',
        address: '',
        address2: '',
        city: '',
        county: '',
        postalCode: '',
        taxRegistrationNumber: '',
        email: '',
        phoneNumber: ''
      },
      formData: {
        orderId: '',
        skus: [
          {
            code: '',
            name: '',
            amount: 0,
            price: 0,
            size: '',
            color: ''
          }
        ],
        shippingAddress: {
          email: '',
          contactNo: '',
          address: '',
          address2: '',
          subDistrict: '',
          district: '',
          stateProvince: '',
          postcode: '',
          country: ''
        },
        brand: '',
        note: '',
        createdAt: '',
        approver: '',
        receiver: '',
        approvedDate: '',
        receivedDate: ''
      },
      gwLogo: GWLogo
    }
  },
  computed: {
    store () {
      return this.$store.getters['Store/store']
    },
    totalPrice () {
      return this.formData.skus.reduce((total, item) => total + item.price, 0)
    },
    totalDiscount () {
      return this.formData.skus.reduce((total, item) => total + (item.quantity * item?.discount || 0), 0)
    },
    beforeVat () {
      return (this.totalPrice - this.totalDiscount)
    },
    vatDiff () {
      return this.beforeVat * (this.vat / 100)
    },
    paymentDueDate () {
      const waitingState = this.formData.stateHistories ? this.formData.stateHistories.find((sh) => sh.state === 'waiting') : null
      if (waitingState) {
        const date = this.$dayjs(new Date(waitingState.createdAt)).add(30, 'day').format('DD/MM/YYYY')
        return date
      }

      const date = this.$dayjs(new Date(this.formData.createdAt)).add(30, 'day').format('DD/MM/YYYY')
      return date
    },
    afterVat () {
      return Number((this.beforeVat + this.vatDiff).toFixed(2))
    },
    billerAddress () {
      const country = ShippingCountries.find((item) => item.code === this.biller.countryLetterCode)?.country || this.biller.countryLetterCode

      return [
        `${this.biller.address} ${this.biller.address2}`,
        this.biller.subDistrict,
        this.biller.city,
        this.biller.county,
        this.biller.postalCode,
        country
      ].filter((v) => !!v).join(', ')
    },
    shippingAddress () {
      return [
        `${this.formData.shippingAddress.address} ${this.formData.shippingAddress.address2}`,
        this.formData.shippingAddress.subDistrict,
        this.formData.shippingAddress.district,
        this.formData.shippingAddress.stateProvince,
        this.formData.shippingAddress.postcode,
        this.formData.shippingAddress.country
      ].filter((v) => !!v).join(', ')
    }
  },
  mounted () {
    this.getItem()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setLoading: 'Components/setLoading'
    }),
    calLineAmount (item) {
      const unitCost = item.directUnitCost - item.discount
      return unitCost > 0 ? unitCost * item.quantity : 0
    },
    async getItem () {
      try {
        this.loading = true
        this.setLoading({ active: true })

        const { data } = await OrderService.getOrderById(this.$route.params.id)

        this.formData = { ...data }
        this.biller = data?.customer ? data.customer : this.biller

        // this.vat = data.vendor?.countryLetterCode !== 'TH' && data.vendor?.countryLetterCode !== '' ? 0 : 7
        setTimeout(() => window.print(), 1000)
      } catch (error) {
        console.error('getItem', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
        this.loading = false
      }
    },
    bathToText (num) {
      return BahtText(num)
    },
    numToText (num) {
      const toWords = new ToWords()
      const val = Number.isNaN(num) ? 0 : num

      return `${toWords.convert(val)} Baht`
    }
  }
}
</script>

<style lang="scss" scoped>
div[size="A4"] {
  display: block;
  width: 210mm;
  min-height: 297mm;
  margin: 10px auto;
  // padding: calc(12.7mm - 24px);
  background-color: #ffffff;
  word-wrap: break-word;
  page-break-after: always;
  font-family: 'Times New Roman', Times, serif;
  .col {
    position: relative;
  }
}
.page-break {
  page-break-before: always;
}
.page-break-after {
  display: none;
}
.item-table {
  font-size: 14px;
  border-collapse: collapse;
  border-color: #000;
  width: 100%;
}
.item-table th {
  padding: 2px 0px;
  font-size: 12px;
}
.item-table td {
  font-size: 10px;
  padding: 2px 4px;
}
.item-table .item-row td {
  border-top-style: hidden;
  vertical-align: top;
}
.item-table .item-row:first-child td {
  border-top-style: solid;
}
.table-content {
  display: flex;
  flex-direction: column;
}
.white-space-pre {
  white-space: pre-line;
}
.table-content .table-row {
  width: 100%;
  display: grid;
  grid-template-columns: min-content auto;
  column-gap: 16px;
}
.table-content .table-row .table-header {
  font-weight: bold;
  text-wrap: nowrap;
}
@media print {
  .page-break {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
  .page-break-after {
    display: block;
    page-break-after: always;
  }
}
</style>
